import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { BehaviorSubject } from 'rxjs';

import { SvgName } from '../../app.config';
import { Color } from '@api/backend-connector/models';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  standalone: true,
  imports: [AsyncPipe, SvgIconComponent, NgClass],
})
export class AvatarComponent {
  readonly picture$ = new BehaviorSubject<string | undefined | null>(undefined);
  readonly name$ = new BehaviorSubject<string | undefined>(undefined);

  @Input()
  set picture(value: string | undefined | null) {
    this.picture$.next(value);
  }

  @Input()
  set name(value: string | undefined) {
    this.name$.next(value);
  }

  @Input() showName? = false;
  @Input() size: 'md' | 'lg' = 'md';
  @Input() icon: SvgName = 'person';
  @Input() color?: Color;
}
